<template>
  <h2>AI Generated Predictions</h2>
  <br>
  <div class="tiles">
    <div class="category tile full-width">
      <h2>Result</h2>
      <div class="button-wrapper">
        <button class="probability-button">
          <div
            v-for="market in resultMarkets"
            :key="market"
            class="button-label"
            :style="{ width: formatProbability(classes[market]?.probability), backgroundColor: highestProbability(resultMarkets) === market ? '#d4edda' : '#f8f9fa' }"
          >
            <span>{{ market }}</span>
            <span>{{ formatProbability(classes[market]?.probability) }}</span>
            <span class="odds">{{ formatOdds(classes[market]?.['decimal odds']) }}</span>
          </div>
        </button>
      </div>
    </div>

    <div v-for="category in categories" :key="category.name" class="category tile">
      <h2>{{ category.name }}</h2>
      <div class="button-wrapper">
        <button class="probability-button">
          <div
            v-for="market in category.markets"
            :key="market"
            class="button-label"
            :style="{ width: formatProbability(classes[market]?.probability), backgroundColor: highestProbability(category.markets) === market ? '#d4edda' : '#f8f9fa' }"
          >
            <span>{{ market }}</span>
            <span>{{ formatProbability(classes[market]?.probability) }}</span>
            <span class="odds">{{ formatOdds(classes[market]?.['decimal odds']) }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const FOOTBALL_CATEGORIES = [
  { name: 'BTTS', markets: ['BTTS No', 'BTTS Yes'] },
  { name: 'Double Chance', markets: ['Home or Draw', 'Home or Away', 'Away or Draw'] },
  { name: '0.5 Goals', markets: ['Over 0.5', 'Under 0.5'] },
  { name: '1.5 Goals', markets: ['Over 1.5', 'Under 1.5'] },
  { name: '2.5 Goals', markets: ['Over 2.5', 'Under 2.5'] },
  { name: '3.5 Goals', markets: ['Over 3.5', 'Under 3.5'] },
  { name: '4.5 Goals', markets: ['Over 4.5', 'Under 4.5'] },
  { name: 'Home Team Goals 0.5', markets: ['First Team Over 0.5', 'First Team Under 0.5'] },
  { name: 'Away Team Goals 0.5', markets: ['Second Team Over 0.5', 'Second Team Under 0.5'] },
  { name: 'Home Team Goals 1.5', markets: ['First Team Over 1.5', 'First Team Under 1.5'] },
  { name: 'Away Team Goals 1.5', markets: ['Second Team Over 1.5', 'Second Team Under 1.5'] },
  { name: 'Clean Sheet', markets: ['First Team Clean Sheet', 'Second Team Clean Sheet'] }
];

export default {
  props: {
    gameDetails: {
      type: Object,
      required: true
    },
    sport: {
      type: String,
      required: true
    }
  },
  computed: {
    classes() {
      return this.gameDetails?.classes || {};
    },
    isFootball() {
      return this.sport === 'Football';
    },
    resultMarkets() {
      return this.isFootball ? ['Home Win', 'Draw', 'Away Win'] : ['Home Win', 'Away Win'];
    },
    categories() {
      return this.isFootball ? FOOTBALL_CATEGORIES : [];
    }
  },
  methods: {
    highestProbability(markets) {
      let highest = markets[0];
      markets.forEach((market) => {
        if ((this.classes[market]?.probability ?? 0) > (this.classes[highest]?.probability ?? 0)) {
          highest = market;
        }
      });
      return highest;
    },
    formatProbability(probability) {
      return probability !== undefined && probability !== null
        ? `${(probability * 100).toFixed(0)}%`
        : '';
    },
    formatOdds(decimalOdds) {
      return decimalOdds !== undefined && decimalOdds !== null
        ? Number(decimalOdds).toFixed(2)
        : 'N/A';
    }
  }
};
</script>

<style scoped>
.tiles {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.tile {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.full-width {
  grid-column: 1 / -1;
}

.button-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}

.probability-button {
  width: 100%;
  padding: 0;
  border: none;
  display: flex;
  text-align: left;
  overflow: hidden;
  border-radius: 5px;
}

.button-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding: 10px;
  flex-basis: 0;
  border-right: 1px solid #ccc;
  box-sizing: border-box;
}

.button-label:last-child {
  border-right: none;
}

.odds {
  font-weight: bold;
}

h2 {
  color: #495057;
}

@media (max-width: 768px) {
  .tiles {
    grid-template-columns: 1fr;
  }

  .tile,
  .full-width {
    grid-column: 1 / -1;
  }

  .probability-button {
    flex-direction: column;
  }

  .button-label {
    width: 100% !important;
    justify-content: space-between;
    flex-direction: row;
    padding: 12px 10px;
    border-right: none;
    border-bottom: 1px solid #ccc;
  }

  .button-label:last-child {
    border-bottom: none;
  }

  .button-label span:first-child,
  .button-label span:nth-child(2),
  .button-label .odds {
    font-size: 11px;
    font-weight: bold;
  }
}
</style>
